import { Client, Currency, Payment, Enrollment } from '../types/GrooverTypes'
import { PaymentTransaction } from '../types/PaymentTransactionTypes'

export const DEFAULT_CURRENCY: Currency = 'SEK'

export const getCurrencyForClient = (client: Client | null): Currency => {
  return client?.currency || DEFAULT_CURRENCY
}

export const getCurrencySymbol = (currency: Currency): string => {
  switch (currency) {
    case 'EUR':
      return '€'
    case 'NOK':
    case 'SEK':
    default:
      return 'kr'
  }
}

export const getCurrencyFromPaymentTransaction = (transaction: PaymentTransaction | null | undefined): Currency => {
  return transaction?.currency || DEFAULT_CURRENCY
}

export const getCurrencyFromPayment = (payment: Payment | null | undefined): Currency => {
  return (payment?.currency as Currency) || DEFAULT_CURRENCY
}

export const getCurrencyFromEnrollment = (enrollment: Enrollment, client?: Client | null): Currency => {
  return (enrollment.currency as Currency) || getCurrencyForClient(client ?? null)
}
